import { FC, useContext, useEffect } from "react";
import { answersRegistry } from "src/api/config/notifications.config";
import Cross from "src/components/ui-icons/Cross";
import Mark from "src/components/ui-icons/Mark";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItems } from "src/modules/spItems/actions";
import { selectItems } from "src/modules/spItems/selectors";
import { FlexCol } from "src/utils/flexLayouts";
import { FormQuestion } from "./formRegistryTest/FormQuestion";
import { TestRegistryContext } from "../store/testRegistryContext";

interface IProps {
  question: any;
}
export const EditingQuestion: FC<IProps> = ({ question }) => {
  const { state } = useContext(TestRegistryContext);
  const dispatch = useAppDispatch();
  const answers = useAppSelector(state => selectItems(state, answersRegistry));

  useEffect(() => {
    if (!state.addQuestion) {
      dispatch(
        getItems({
          listName: answersRegistry,
          filters: { ID: question.Answers.map((answer: any) => answer.ID) }
        })
      );
    }
  }, [question]);

  return (
    <FlexCol className="rounded-md">
      {!state.addQuestion ? (
        <>
          <div className="flex p-5 rounded-md flex-col gap-[10px] bg-[#F3F4F6]">
            <h3 className="text-black">{question.Title}</h3>
            {answers?.map(answer => (
              <div className="flex items-center" key={answer.ID}>
                <span>{answer.IsCorrect ? <Mark /> : <Cross />}</span>
                <h4 className="text-[#637387]">{answer.Title}</h4>
              </div>
            ))}
          </div>
          <FormQuestion answersQuestion={answers} question={question} />
        </>
      ) : (
        <div>
          <FormQuestion />
        </div>
      )}
    </FlexCol>
  );
};
